import { Button, Card, Stack, Text } from '@mantine/core'
import type { VisitWithRelations } from '@markku/types'
import { IconChevronRight, IconClipboardCheck } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import { Trans } from '@lingui/react/macro'

interface PropertySurveyCardProps {
  visit: VisitWithRelations
}

export function PropertySurveyCard({ visit }: PropertySurveyCardProps) {
  if (!visit.propertyId) {
    return null
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        <Stack gap="xs">
          <Text size="lg" fw={600}>
            <IconClipboardCheck
              size={20}
              style={{ verticalAlign: 'middle', marginRight: 8 }}
            />
            <Trans>Property information updated</Trans>
          </Text>
          <Text size="sm" c="dimmed">
            <Trans>
              During the visit, your property information was surveyed and
              updated.
            </Trans>
          </Text>
        </Stack>

        <Button
          variant="light"
          fullWidth
          to={`/properties/${visit.propertyId}`}
          component={Link}
          rightSection={<IconChevronRight size={16} />}
        >
          <Trans>View property details</Trans>
        </Button>
      </Stack>
    </Card>
  )
}
